import { Box, Flex } from '@chakra-ui/react'

export function StepDivider({ vertical }: { vertical?: boolean }) {
  if (vertical)
    return (
      <Flex justifyContent={'center'} w={'full'}>
        <Box h={'20px'} w={'1px'} bgColor={'custom.gray.600'} />
      </Flex>
    )
  return (
    <Flex alignItems={'center'} w={'full'}>
      <Box h={'1px'} w={'full'} bgColor={'custom.gray.600'} />
    </Flex>
  )
}
